'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Col = exports.Row = exports.Container = exports.Order = exports.Hidden = exports.Visible = undefined;

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  box-sizing: border-box;\n'], ['\n  box-sizing: border-box;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: block;\n'], ['\n  display: block;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  display: none;\n'], ['\n  display: none;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  order: ', ';\n'], ['\n  order: ', ';\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n    ', '\n    ', '\n    ', '\n    ', '\n    ', '\n    ', '\n    ', '\n  \n    ', '\n    ', '\n    ', '\n    ', '\n    ', '\n    ', '\n  '], ['\n    ', '\n    ', '\n    ', '\n    ', '\n    ', '\n    ', '\n    ', '\n  \n    ', '\n    ', '\n    ', '\n    ', '\n    ', '\n    ', '\n  ']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['', ' ', ''], ['', ' ', '']),
    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n'], ['\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n']),
    _templateObject8 = (0, _taggedTemplateLiteral3.default)(['\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n'], ['\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n']);

var _reactAwesomeStyledGrid = require('react-awesome-styled-grid');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsBreakpoint = require('styled-components-breakpoint');

var _styledComponentsBreakpoint2 = _interopRequireDefault(_styledComponentsBreakpoint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BorderBoxedContainer = (0, _styledComponents2.default)(_reactAwesomeStyledGrid.Container)(_templateObject);

var show = (0, _styledComponents.css)(_templateObject2);
var hide = (0, _styledComponents.css)(_templateObject3);

var order = function order(num) {
  return (0, _styledComponents.css)(_templateObject4, num);
};

var withBreakpoints = function withBreakpoints(Comp) {
  return (0, _styledComponents2.default)(Comp)(_templateObject5, function (_ref) {
    var hidden = _ref.hidden;
    return hidden === 'xs' && (0, _styledComponentsBreakpoint2.default)('xs')([hide]);
  }, function (_ref2) {
    var hidden = _ref2.hidden;
    return hidden === 'sm' && (0, _styledComponentsBreakpoint2.default)('sm')([hide]);
  }, function (_ref3) {
    var hidden = _ref3.hidden;
    return hidden === 'md' && (0, _styledComponentsBreakpoint2.default)('md')([hide]);
  }, function (_ref4) {
    var hidden = _ref4.hidden;
    return hidden === 'lg' && (0, _styledComponentsBreakpoint2.default)('lg')([hide]);
  }, function (_ref5) {
    var hidden = _ref5.hidden;
    return hidden === 'xl' && (0, _styledComponentsBreakpoint2.default)('xl')([hide]);
  }, function (_ref6) {
    var hidden = _ref6.hidden;
    return hidden === 'xlhc' && (0, _styledComponentsBreakpoint2.default)('xlhc')([hide]);
  }, function (_ref7) {
    var hidden = _ref7.hidden;
    return hidden === 'xlsc' && (0, _styledComponentsBreakpoint2.default)('xlsc')([hide]);
  }, function (_ref8) {
    var visible = _ref8.visible;
    return visible === 'sm' && (0, _styledComponents.css)(_templateObject6, (0, _styledComponentsBreakpoint2.default)('xs')([hide]), (0, _styledComponentsBreakpoint2.default)('sm')([show]));
  }, function (_ref9) {
    var visible = _ref9.visible;
    return visible === 'md' && (0, _styledComponents.css)(_templateObject6, (0, _styledComponentsBreakpoint2.default)('xs')([hide]), (0, _styledComponentsBreakpoint2.default)('md')([show]));
  }, function (_ref10) {
    var visible = _ref10.visible;
    return visible === 'lg' && (0, _styledComponents.css)(_templateObject6, (0, _styledComponentsBreakpoint2.default)('xs')([hide]), (0, _styledComponentsBreakpoint2.default)('lg')([show]));
  }, function (_ref11) {
    var visible = _ref11.visible;
    return visible === 'xl' && (0, _styledComponents.css)(_templateObject6, (0, _styledComponentsBreakpoint2.default)('xs')([hide]), (0, _styledComponentsBreakpoint2.default)('xl')([show]));
  }, function (_ref12) {
    var visible = _ref12.visible;
    return visible === 'xlhc' && (0, _styledComponents.css)(_templateObject6, (0, _styledComponentsBreakpoint2.default)('xs')([hide]), (0, _styledComponentsBreakpoint2.default)('xlhc')([show]));
  }, function (_ref13) {
    var visible = _ref13.visible;
    return visible === 'xlsc' && (0, _styledComponents.css)(_templateObject6, (0, _styledComponentsBreakpoint2.default)('xs')([hide]), (0, _styledComponentsBreakpoint2.default)('xlsc')([show]));
  });
};

var Visible = exports.Visible = _styledComponents2.default.div(_templateObject7, hide, function (_ref14) {
  var xs = _ref14.xs;
  return xs && (0, _styledComponentsBreakpoint2.default)('xs')([show]);
}, function (_ref15) {
  var sm = _ref15.sm;
  return sm && (0, _styledComponentsBreakpoint2.default)('sm')([show]);
}, function (_ref16) {
  var md = _ref16.md;
  return md && (0, _styledComponentsBreakpoint2.default)('md')([show]);
}, function (_ref17) {
  var lg = _ref17.lg;
  return lg && (0, _styledComponentsBreakpoint2.default)('lg')([show]);
}, function (_ref18) {
  var xl = _ref18.xl;
  return xl && (0, _styledComponentsBreakpoint2.default)('xl')([show]);
}, function (_ref19) {
  var xlhc = _ref19.xlhc;
  return xlhc && (0, _styledComponentsBreakpoint2.default)('xlhc')([show]);
}, function (_ref20) {
  var xlsc = _ref20.xlsc;
  return xlsc && (0, _styledComponentsBreakpoint2.default)('xlsc')([show]);
});

var Hidden = exports.Hidden = _styledComponents2.default.div(_templateObject7, show, function (_ref21) {
  var xs = _ref21.xs;
  return xs && (0, _styledComponentsBreakpoint2.default)('xs')([hide]);
}, function (_ref22) {
  var sm = _ref22.sm;
  return sm && (0, _styledComponentsBreakpoint2.default)('sm')([hide]);
}, function (_ref23) {
  var md = _ref23.md;
  return md && (0, _styledComponentsBreakpoint2.default)('md')([hide]);
}, function (_ref24) {
  var lg = _ref24.lg;
  return lg && (0, _styledComponentsBreakpoint2.default)('lg')([hide]);
}, function (_ref25) {
  var xl = _ref25.xl;
  return xl && (0, _styledComponentsBreakpoint2.default)('xl')([hide]);
}, function (_ref26) {
  var xlhc = _ref26.xlhc;
  return xlhc && (0, _styledComponentsBreakpoint2.default)('xlhc')([hide]);
}, function (_ref27) {
  var xlsc = _ref27.xlsc;
  return xlsc && (0, _styledComponentsBreakpoint2.default)('xlsc')([hide]);
});

var Order = exports.Order = _styledComponents2.default.div(_templateObject8, function (_ref28) {
  var xs = _ref28.xs;
  return xs != null && (0, _styledComponentsBreakpoint2.default)('xs')([order(xs)]);
}, function (_ref29) {
  var sm = _ref29.sm;
  return sm != null && (0, _styledComponentsBreakpoint2.default)('sm')([order(sm)]);
}, function (_ref30) {
  var md = _ref30.md;
  return md != null && (0, _styledComponentsBreakpoint2.default)('md')([order(md)]);
}, function (_ref31) {
  var lg = _ref31.lg;
  return lg != null && (0, _styledComponentsBreakpoint2.default)('lg')([order(lg)]);
}, function (_ref32) {
  var xl = _ref32.xl;
  return xl != null && (0, _styledComponentsBreakpoint2.default)('xl')([order(xl)]);
}, function (_ref33) {
  var xlhc = _ref33.xlhc;
  return xlhc != null && (0, _styledComponentsBreakpoint2.default)('xlhc')([order(xlhc)]);
}, function (_ref34) {
  var xlsc = _ref34.xlsc;
  return xlsc != null && (0, _styledComponentsBreakpoint2.default)('xlsc')([order(xlsc)]);
});

var Container = exports.Container = withBreakpoints(BorderBoxedContainer);
var Row = exports.Row = withBreakpoints(_reactAwesomeStyledGrid.Row);
var Col = exports.Col = withBreakpoints(_reactAwesomeStyledGrid.Col);